import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Popover,
  PopoverBody,
  Row,
} from "reactstrap";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import {
  salesOrderResponseToTable,
  mapSearchCustomerAutoSuggestion,
} from "../../../utils/mapper";
import { customerAutoSuggestionApi } from "../../../services/order";
import { useDispatch, useSelector } from "react-redux";
import withReducer from "../../../store/withReducer";
import Slider from "react-slick";

import salesOrderReducer from "../store";
import {
  getSalesOrders,
  selectSalesOrder,
  setSettings,
  getSalesOrderFilters,
  downloadSalesOrderPickingTicketPdf,
  setSalesOrderPendingPickingDialogProps,
  setSalesOrderPendingPackingDialogProps,
  getSalesOrderStatuses,
  downloadSalesOrderPickingTickeBinPdf,
  updateSalesOrderStatus,
} from "../store/salesOrderSlice";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import PreLoader from "../../../share-components/ui/preLoader";
import { DateRangePicker } from "rsuite";
import { NormalCarouseNavigation } from "../../../utils/common";
import { setSalesFulfillmentDialog } from "../store/salesOrderStatusSlice";
import PendingPickingModal from "./content/pendingPickingModal";
import PendingPackingModal from "./content/pendingPackingModal";
import SalesFulfillmentModal from "./status/content/salesFulfillmentModal";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { inventorySkuApi } from "../../../services/manage-product/productService";

const { afterToday } = DateRangePicker;

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const statusSettings = {
  className: "slider variable-width",
  dots: false,
  infinite: false,
  slidesToShow: 7,
  slidesToScroll: 1,
  nextArrow: <NormalCarouseNavigation icon="fa-chevron-circle-right" />,
  prevArrow: <NormalCarouseNavigation icon="fa-chevron-circle-left" />,
  variableWidth: false,
  initialSlide: 0,
};

const defaultValues = {
  id: "",
};

const SalesOrder = (props) => {
  const [timer, setTimer] = useState(null);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [brand, setBrand] = useState(null);
  const [type, setType] = useState(null);
  const [status, setStatus] = useState(null);
  const [statusList, setStatusList] = useState([]);
  const [sku, setSku] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [search, setSearch] = useState(null);
  const [loading, isSetLoading] = useState(true);
  const salesOrders = useSelector(selectSalesOrder);
  let history = useHistory();
  const salesOrderState = useSelector(({ order }) => order.salesOrder);
  const userState = useSelector(({ authReducer }) => authReducer.data);
  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
  const [startDate, endDate] = dateRange;
  const authData = useSelector(({ authReducer }) => authReducer);
  const saleOrderState = useSelector(({ order }) => order.salesOrder);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [activeStatus, setActiveStatus] = useState(-1);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [options, setOptions] = useState([]);
  const [variant, setVariant] = useState("");

  const togglePopover = (rowId) => {
    setPopoverOpen((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId],
    }));
  };
  const { setValue, trigger, getValues } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const dataMenu = [
    {
      type: 0,
      text: "Sales Order",
    },
  ];

  const tableColumns = [
    {
      name: "Order No.",
      selector: (row) => row.order_no,
      sortable: true,
      center: false,
    },
    {
      name: "Shopify Order ID",
      selector: (row) =>
        row.shopify_order_no ? row.shopify_order_no : "-----",
      sortable: true,
      center: false,
    },
    {
      name: "Customer",
      selector: (row) => row.customer,
      sortable: true,
      center: false,
    },
    {
      name: "Order Type",
      selector: (row) => row.type,
      sortable: true,
      center: false,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      center: false,
    },
    {
      name: "Country",
      selector: (row) => row.country,
      sortable: true,
      center: false,
    },
    {
      name: "Amount",
      selector: (row) => <>{row.total}</>,
      sortable: true,
      center: false,
    },
    {
      name: "Payment Method",
      selector: (row) => row.payment_method,
      sortable: true,
      center: false,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      center: false,
    },
    // closedReasonColumn && {
    //   name: "Closed Reason",
    //   selector: (row) => row.closed_reason,
    //   sortable: true,
    //   center: false,
    // },
    {
      name: "Action",
      width: "15%",
      selector: (row) => (
        <div>
          {userState.user &&
            (userState.user.permission.indexOf("View Seller") !== -1 ? (
              <Link
                to={`${process.env.PUBLIC_URL}/order/sale/${row.id}/view`}
                className="mr-1"
                title="Sales Order View"
              >
                <i
                  className="fa fa-eye"
                  style={{
                    fontSize: 16,
                    color: "rgb(51, 153, 255)",
                  }}
                ></i>
              </Link>
            ) : (
              ""
            ))}
          {!row.is_closed && (
            <>
              {!row.is_online && (
                <Link
                  to={`${process.env.PUBLIC_URL}/order/sale/${row.id}/edit`}
                  className="mr-1"
                  title="Sales Order Edit"
                >
                  <i
                    style={{
                      fontSize: 16,
                      color: "rgb(40, 167, 69)",
                    }}
                    className="icon-pencil"
                  ></i>
                </Link>
              )}
              {row.status_id !== 0 ? (
                <>
                  {userState.user &&
                    (userState.user.permission.indexOf("Update Seller") !==
                    -1 ? (
                      <Link
                        to={`${process.env.PUBLIC_URL}/order/sale/${row.id}/billing/invoice`}
                        title="Sales Order Billing"
                      >
                        <i
                          className="fa fa-file-text-o"
                          style={{
                            fontSize: 16,
                            color: "rgb(255, 187, 51)",
                          }}
                        ></i>
                      </Link>
                    ) : (
                      ""
                    ))}
                </>
              ) : (
                ""
              )}
            </>
          )}
          {row.status_id == 0 ? (
            ""
          ) : (
            <>
              {row.sum_back_order_quantity === 0 ? (
                <>
                  <Popover
                    placement="top"
                    isOpen={popoverOpen[row.id] || false}
                    target={`pickingTicketPopover-${row.id}`}
                    toggle={() => togglePopover(row.id)}
                    trigger="hover"
                  >
                    <PopoverBody className="text-center">
                      <Col className="mb-2">
                        <Button
                          color="success"
                          className="mr-1"
                          onClick={() => downloadPickingTicket(row)}
                        >
                          Picking Ticket by Style
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          color="primary"
                          className="mr-1"
                          onClick={() => downloadBinPickingTicket(row)}
                        >
                          Picking Ticket by Bin
                        </Button>
                      </Col>
                    </PopoverBody>
                  </Popover>

                  {/* Button triggering the popover */}
                  <i
                    id={`pickingTicketPopover-${row.id}`}
                    className="fa fa-ticket"
                    style={{
                      fontSize: 16,
                      color: "rgb(0, 230, 77)",
                    }}
                  ></i>
                </>
              ) : (
                ""
              )}
            </>
          )}
          {row.status_id == 2 ? (
            <>
              <button
                onClick={() => uploadPickingTicket(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="Upload Picking Ticket"
              >
                <i
                  className="fa fa-upload"
                  style={{
                    fontSize: 16,
                    color: "rgb(196, 77, 255)",
                  }}
                ></i>
              </button>
            </>
          ) : (
            ""
          )}
          {row.status_id == 3 ? (
            <>
              <button
                onClick={() => viewPickingTicket(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="View Picking Ticket"
              >
                <i
                  className="fa fa-file-text"
                  style={{
                    fontSize: 16,
                    color: "rgb(0, 230, 230)",
                  }}
                ></i>
              </button>
            </>
          ) : (
            ""
          )}
          {row.status_id == 4 ? (
            <>
              <button
                onClick={() => downloadPackingInvoice(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="Download Invoice"
              >
                <i
                  className="fa fa-cloud-download"
                  style={{
                    fontSize: 16,
                    color: "rgb(102, 0, 255)",
                  }}
                ></i>
              </button>
              <button
                onClick={() => viewPickingTicket(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="View Picking Ticket"
              >
                <i
                  className="fa fa-file-text"
                  style={{
                    fontSize: 16,
                    color: "rgb(0, 230, 230)",
                  }}
                ></i>
              </button>
            </>
          ) : (
            ""
          )}
          {row.status_id == 5 ? (
            <>
              <button
                onClick={() => createShippingFulfillment(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="Create Fulfillment"
              >
                <i
                  className="fa fa-truck"
                  style={{
                    fontSize: 16,
                    color: "rgb(255, 204, 102)",
                  }}
                ></i>
              </button>
              <button
                onClick={() => viewPickingTicket(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="View Picking Ticket"
              >
                <i
                  className="fa fa-file-text"
                  style={{
                    fontSize: 16,
                    color: "rgb(0, 230, 230)",
                  }}
                ></i>
              </button>
            </>
          ) : (
            ""
          )}
          {row.status_id == 6 ? (
            <>
              <button
                onClick={() => viewPickingTicket(row)}
                className="mr-1"
                style={{ background: "none" }}
                title="View Picking Ticket"
              >
                <i
                  className="fa fa-file-text"
                  style={{
                    fontSize: 16,
                    color: "rgb(0, 230, 230)",
                  }}
                ></i>
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      ),
      sortable: false,
      center: true,
    },
  ];

  const allStatusClick = () => {
    handleStatusClick(1);
    setActiveStatus(-1);
  };

  const handleStatusClick = (selectedStatus) => {
    setStatus(selectedStatus.id);
    setActiveStatus(selectedStatus.id);
  };

  useEffect(() => {
    getData();
  }, [
    page,
    brand,
    search,
    dateRange,
    startDate,
    endDate,
    type,
    status,
    sku,
    customer,
  ]);

  const getData = () => {
    const data = {
      page: page,
      pageSize: 10,
      brand: brand,
      search: search,
      type: type,
      status: status,
      sku: sku,
      customer: customer,
      dateRange: dateRange,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
    };
    dispatch(getSalesOrders(data)).then((res) => {
      if (!res.error) {
        // isSetLoading(false);
      }
    });
  };

  useEffect(() => {
    // isSetLoading(true);
    const data = {
      brand: brand,
      search: search,
      type: type,
      sku: sku,
      customer: customer,
      dateRange: dateRange,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
    };
    dispatch(getSalesOrderFilters()).then((res) => {
      if (!res.error) {
        dispatch(setSettings(res.payload));
      }
    });
    dispatch(getSalesOrderStatuses(data)).then((res) => {
      if (!res.error) {
        setStatusList(res.payload);
        isSetLoading(false);
      }
    });
  }, [brand, search, dateRange, type, status, sku, customer]);

  const onInvoiceEdit = (row) => {
    history.push("sale/" + row.id + "/billing/invoice");
  };
  const onEdit = (row) => {
    history.push("sale/" + row.id + "/edit");
  };
  const onView = (row) => {
    history.push("sale/" + row.id + "/view");
  };
  const onAdd = () => {
    history.push("sale/create");
  };

  const downloadPickingTicket = (row) => {
    processPDFDownload("Picking Ticket By Style", row.id, row.order_no);
    setPopoverOpen(false);

    const orderId = row.id;
    if (orderId) {
      const currentStatus = row.status_id;
      if (currentStatus === 1) {
        dispatch(updateSalesOrderStatus({ id: orderId, status_id: 2 }))
          .then((res) => {
            if (!res.error) {
              console.log(
                "Status updated to Pending Picking after downloading picking ticket"
              );
            }
            getData();
          })
          .catch((error) => {
            console.error("Error updating status:", error);
            isSetLoading(false);
          });
      }
    }
  };

  const downloadBinPickingTicket = (row) => {
    processPickingBinPDFDownload("Picking Ticket By Bin", row.id, row.order_no);
    setPopoverOpen(false);

    const orderId = row.id;
    if (orderId) {
      const currentStatus = row.status_id;
      if (currentStatus === 1) {
        dispatch(updateSalesOrderStatus({ id: orderId, status_id: 2 }))
          .then((res) => {
            if (!res.error) {
              console.log(
                "Status updated to Pending Picking after downloading picking ticket"
              );
            }
            getData();
          })
          .catch((error) => {
            console.error("Error updating status:", error);
            isSetLoading(false);
          });
      }
    }
  };

  const uploadPickingTicket = (row) => {
    const data = {
      props: { isOpen: true },
      type: "edit",
      data: row,
      isInputShow: true,
    };

    dispatch(setSalesOrderPendingPickingDialogProps(data));
  };

  const viewPickingTicket = (row) => {
    const data = {
      props: { isOpen: true },
      type: "edit",
      data: row,
      isInputShow: false,
    };

    dispatch(setSalesOrderPendingPickingDialogProps(data));
  };

  const downloadPackingInvoice = (row) => {
    const data = {
      props: { isOpen: true },
      type: "edit",
      data: row,
    };

    dispatch(setSalesOrderPendingPackingDialogProps(data));
  };

  const createShippingFulfillment = (row) => {
    const data = {
      props: { isOpen: true },
      type: "edit",
      data: row,
    };

    dispatch(setSalesFulfillmentDialog(data));
  };

  const processPDFDownload = (name, id, orderNumber) => {
    const orderId = id;
    const orderNo = orderNumber;
    const data = {
      id: orderId,
      params: {
        name: name,
        seller: authData.defaultSeller?.value,
      },
    };

    dispatch(downloadSalesOrderPickingTicketPdf(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${orderNo}_${name.replace(/\s+/g, "-")}_${new Date()
          .toJSON()
          .slice(0, 10)}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const processPickingBinPDFDownload = (name, id, orderNumber) => {
    const orderId = id;
    const orderNo = orderNumber;
    const data = {
      id: orderId,
      params: {
        name: name,
        seller: authData.defaultSeller?.value,
      },
    };
    dispatch(downloadSalesOrderPickingTickeBinPdf(data)).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${orderNo}_${name.replace(/\s+/g, "-")}_${new Date()
          .toJSON()
          .slice(0, 10)}.pdf`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const typePromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(
          mapSearchCustomerAutoSuggestion(customerAutoSuggestionApi(data))
        );
      });
    });

  const handleCustomerChange = (selectedOption) => {
    setCustomer(selectedOption ? selectedOption.value : null);
  };

  const handleSearch = async (query) => {
    try {
      const response = await inventorySkuApi(query);
      const data = response;
      setOptions(data.response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      isSetLoading(false);
    }
  };

  return (
    <Fragment>
      {loading ? (
        <>
          <PreLoader></PreLoader>
        </>
      ) : (
        <>
          <Breadcrumb title="Sales Order" data={dataMenu} />

          <Container fluid={true} className="product-wrapper">
            <div className="product-grid">
              <div className="feature-products">
                {currentUser.permission.includes("Create Seller") ? (
                  <Card>
                    {userState.user &&
                      (userState.user.permission.indexOf("Add Seller") !==
                      -1 ? (
                        <Row>
                          <Col md={3}>
                            <Form>
                              <FormGroup className="row pt-2">
                                <Col
                                  sm="12"
                                  style={{
                                    border: "1px solid #ddd",
                                    marginLeft: 42,
                                    borderRadius: 6,
                                  }}
                                >
                                  <DatePicker
                                    dateRange={dateRange}
                                    dateRangeChange={(update) => {
                                      setDateRange(update);
                                    }}
                                    disabledDate={afterToday()}
                                    defaultValue={[TodayDate, sevenDays]}
                                  />
                                </Col>
                              </FormGroup>
                            </Form>
                          </Col>
                          <Col md={9} className="pt-1">
                            <div className="float-sm-right p-3">
                              <a
                                onClick={onAdd}
                                className="btn btn-sm btn-primary"
                              >
                                {" "}
                                <i className="fa fa-plus"></i> Add Sales Order
                              </a>
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      ))}
                  </Card>
                ) : (
                  ""
                )}

                <Row className="pb-2">
                  <Col md={12} className="slick-arrow">
                    {statusList.length > 0 && (
                      <Slider {...statusSettings}>
                        <div
                          className={
                            activeStatus == -1
                              ? "active-status p-1 mx-1"
                              : "p-1 mx-1"
                          }
                          style={{ width: "auto" }}
                        >
                          <div className="slider-item" data-index={0}>
                            <div>
                              <button
                                style={{ background: "none" }}
                                onClick={allStatusClick}
                              >
                                <span>
                                  <i
                                    className="fa fa-bars"
                                    style={{
                                      fontSize: 18,
                                      paddingTop: 4,
                                      color: "rgb(102, 179, 255)",
                                    }}
                                  ></i>
                                  <span
                                    style={{
                                      paddingLeft: 10,
                                      fontSize: 14,
                                      marginLeft: 5,
                                    }}
                                  >
                                    All
                                  </span>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        {statusList.map((item, i) => (
                          <div
                            className={
                              activeStatus == item.id
                                ? "active-status p-1 mx-1"
                                : "p-1 mx-1"
                            }
                            key={i}
                            style={{ width: "auto" }}
                          >
                            <div>
                              <button
                                style={{ background: "none" }}
                                onClick={() => handleStatusClick(item)}
                              >
                                <span>
                                  <i
                                    className={item.icon}
                                    style={{
                                      fontSize: 18,
                                      paddingTop: 4,
                                      color: item.color,
                                    }}
                                  ></i>
                                  <span
                                    style={{
                                      paddingLeft: 10,
                                      fontSize: 14,
                                      marginLeft: 5,
                                    }}
                                  >
                                    {item.name} ({item.count})
                                  </span>
                                </span>
                              </button>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col sm="3">
                    <Select
                      className="select2-filter border"
                      isClearable
                      cacheOptions
                      styles={customStyles}
                      placeholder="Select Type"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e) => {
                        setType(e ? e.id : null);
                        setPage(1);
                      }}
                      options={
                        salesOrderState.settings
                          ? salesOrderState.settings.types
                          : null
                      }
                    />
                  </Col>

                  <Col sm="3">
                    <AsyncSelect
                      isClearable
                      cacheOptions
                      defaultOptions
                      styles={customStyles}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      loadOptions={typePromiseOption}
                      onChange={handleCustomerChange}
                      placeholder="Select Customer"
                    />
                  </Col>

                  <Col sm="3">
                    <Form>
                      <FormGroup>
                        <AsyncTypeahead
                          minLength={1}
                          id="async-typeahead"
                          filterBy={() => true}
                          isLoading={loading}
                          labelKey="sku"
                          onSearch={handleSearch}
                          onChange={(selected) => {
                            clearTimeout(timer);

                            const newTimer = setTimeout(() => {
                              setSku(selected[0]?.sku);
                            }, 3000);

                            setTimer(newTimer);
                          }}
                          options={options}
                          placeholder="Search by SKU."
                          key={variant ? variant.id : 0}
                          defaultSelected={variant ? [variant] : []}
                        />
                      </FormGroup>
                    </Form>
                  </Col>

                  <Col sm="3">
                    <Form>
                      <FormGroup className="m-0">
                        <Input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            clearTimeout(timer);

                            const newTimer = setTimeout(() => {
                              setSearch(e.target.value);
                            }, 3000);

                            setTimer(newTimer);
                          }}
                          placeholder="Search by Order/Shopify Order No."
                        />
                        <i className="fa fa-search"></i>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
              </div>
            </div>
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <div className="table-responsive product-table">
                      <CommonDataTable
                        headerColumns={tableColumns}
                        gridData={salesOrderResponseToTable(salesOrders)}
                        onEdit={
                          currentUser.permission.includes("Update Seller")
                            ? onEdit
                            : ""
                        }
                        onView={
                          currentUser.permission.includes("View Seller")
                            ? onView
                            : ""
                        }
                        noAction
                        paginationServer
                        pagination
                        paginationTotalRows={saleOrderState.noOfTableRows}
                        paginationComponentOptions={{
                          noRowsPerPage: true,
                        }}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        paginationPerPage={10}
                        onChangePage={(page) => setPage(page)}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <PendingPickingModal
                orderSetValue={setValue}
                orderTrigger={trigger}
                orderGetValues={getValues}
              ></PendingPickingModal>

              <PendingPackingModal
                orderSetValue={setValue}
                orderTrigger={trigger}
                orderGetValues={getValues}
              ></PendingPackingModal>

              <SalesFulfillmentModal
                orderSetValue={setValue}
                orderTrigger={trigger}
                orderGetValues={getValues}
              ></SalesFulfillmentModal>
            </Row>
          </Container>
        </>
      )}
    </Fragment>
  );
};

export default withReducer([
  {
    salesOrders: salesOrderReducer,
  },
])(SalesOrder);
